/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable eqeqeq */
import React from "react";
import { CartContext } from "../../CartContext";
import { useContext } from "react";
import {
  toFixed,
  find,
  getImageExtension,
  validateNumber,
  getDefValues,
  getImagePath,
  getComboLabel,
} from "../../common/functions";

import { updateOptionsAll, addShopCartV2, addEventCartV2 } from "../../common/functionsV2";

import defaultImage from "../../assets/images/default.jpg";
const windowWidth = window.innerWidth;
const LoadProduct = (props) => {
  const { shopCart, setShopCart, updatingShopCart, setUpdatingShopCart,
    setEventQty, setUpdatingEventCart,
  } =
    useContext(CartContext);
  var skucomment = "";

  var target = "_self";
  var action = "";

  var elementId = "";

  if (props.productConfig.fatherConfig) {
    if (
      props.productConfig.fatherConfig.action &&
      props.productConfig.fatherConfig.id
    ) {
      action = props.productConfig.fatherConfig.action;
      elementId = props.productConfig.fatherConfig.id;
      //target= "_blank"
      target = "_self";
      //linkInfo =  linkInfo+ ( props.productData.skuCloned?"&":"?" ) +"action="+action+"&id="+elementId+ ( qRequested==""?"": "&q="+qRequested )
    }
  }

  const [path, setPath] = React.useState(null);
  const [qRequested, setqRequested] = React.useState(0);



  const [showComment, setShowComment] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [quantities, setQuantities] = React.useState([]);

  const [optionsselected, setOptionsselected] = React.useState([]);
  const [priceold, setPriceold] = React.useState("");

  const [discount, setDiscount] = React.useState(0);
  const [pricenew, setPricenew] = React.useState("");

  const [storequantities, setStorequantities] = React.useState([]);
  const [banned, setBanned] = React.useState([]);

  const [sku, setSku] = React.useState("");
  const [quantity, setQuantity] = React.useState(1);

  const [selectedColor, setSelectedColor] = React.useState("");
  const [selectedSize, setSelectedSize] = React.useState("");
  const [storeId, setStoreId] = React.useState("");
  const [product, setProduct] = React.useState({});
  const [linkInfo, setLinkInfo] = React.useState("");

  React.useEffect(() => {
    const _quantities = props.productData.quantities ?? []
    const _storequantities = props.productData.storequantities
    const _storeId = Number(props.productData.storeId);

    var _linkInfo =
      (props.productData.category
        ? "/" + props.productData.category + "/"
        : "/productDetails/") +
      (props.productData.productpath
        ? props.productData.productpath
        : props.productData.label) +
      (props.productData.skuCloned
        ? "?suggestedcolor_" + props.productData.skuCloned
        : "");
    setLinkInfo(_linkInfo)
    setSku(props.productData.productmodel);
    setStoreId(_storeId);
    setOptions(props.productData.options);
    setQuantities(_quantities);
    setStorequantities(_storequantities);
    if (props.productConfig.optionsselected) {
      setSelectedColor(props.productConfig.optionsselected[0]?.optionvalue ?? "");
      setSelectedSize(props.productConfig.optionsselected[1]?.optionvalue ?? "");
      setOptionsselected(props.productConfig.optionsselected);
    }
    if (_quantities) {
      if (_quantities[0].quantityrequested) {
        setqRequested(_quantities[0].quantityrequested)
      }
      if (_quantities[0].skucomment) {
        skucomment = _quantities[0].skucomment;
      }
    }
    setPriceold(props.productData.priceold);
    setDiscount(props.productData.discount);
    setPricenew(props.productData.pricenew);
    setPath(props.productData.path);
    let _product = {
      productsku: props.productData.productmodel,
      productid: props.productData.productid,
      label: props.productData.label,
      categoryid: props.productData.categoryid || 0,
      category: props.productData.category || "",
      priceold: props.productData.priceold,
      maxQuantity: props.productData.maxQuantity.quantity ?? props.productData.maxQuantity,
      path: props.productData.path, //image
      productpath: props.productData.productpath,
      options: props.productData.options,
      quantities: _quantities,
      features: _quantities,
      sku: props.productData.productmodel,
      optionsselected: props.productConfig.optionsselected,
      skus: [], //skus, //PACKS REVISAR 
      eventid: props.productData.eventid
    };
    //console.log("_product:::",props, _product)
    setProduct(_product);
    //  console.log("skucomment", skucomment, _product)
  }, [props]);
  const toggleShowComment = (sku) => {
    setShowComment(!showComment);
  };
  
  const selectImage = (imagePath) => {
    try {
      const extemsion=  getImageExtension();
      let _data = imagePath.split("/");
      let _sku = _data[_data.length - 1].split("_");
      let sku = "";
      for (let s in _sku) {
        if (s < _sku.length - 1) {
          sku = sku + "_" + _sku[s];
        }
      }
      sku = sku.substr(1, sku.length);
      let pos = find(quantities, sku, "sku");
      if (pos > 0) {
        let option = quantities[pos];
        if (option.imagesquantity > 1) {
          if (_sku[_sku.length - 1] == "1.jpg") {
            setPath(option.imagespath + sku + "_2" + extemsion);
          } else {
            setPath(option.imagespath + sku + "_1" + extemsion);
          }
        }
      } else {
        if (imagePath.endsWith("1.jpg")) {
          setPath(imagePath.replace("1.jpg", "2.jpg"));
        } else {
          setPath(imagePath.replace("2.jpg", "1.jpg"));
        }
      }


    } catch (Exc) { }
  };

  const manageProdCartColor = (_event, banned, optionvalue, sku) => {

    const pricesBySku = new Map();

    if (process.env.REACT_APP_URL_CONFIG === "http://localhost:8081") {
      console.log("manageProdCartColor _event:", _event)
      console.log("manageProdCartColor banned:", banned)
      console.log("manageProdCartColor optionvalue:", optionvalue)
      console.log("manageProdCartColor sku:", sku)
      console.log("qRequested sku:", qRequested)
      //console.log("storequantities", JSON.stringify(storequantities))
      //console.log("quantities", JSON.stringify(quantities))
    }

    for (const p of quantities) {
      pricesBySku.set(String(p.sku), {
        newpriced: p.newpriced,
        newpriced2: p.newpriced2,
        newpricec1: p.newpricec1,
        newpricec2: p.newpricec2,
        specificname: p.specificname

      });
    }
    const updatedStoreQuantities = storequantities.map(item => {
      if (Number(item.storeid) !== Number(storeId)) return item;
      const priceInfo = pricesBySku.get(String(item.sku));
      if (!priceInfo) return item;
      return {
        ...item,
        ...priceInfo
      };
    });
    try {
      let validateOption = updateOptionsAll(
        storeId,
        optionvalue,
        selectedSize,
        updatedStoreQuantities, // ANTES storequantities,
        options,
        props.productConfig.sizes,
        null
      );
      setOptions(validateOption.newOptions);
      setSelectedColor(validateOption.newColor);
      setSelectedSize(validateOption.newSize);

      setPriceold(validateOption.sku.price);

      setDiscount(validateOption.sku.newpriced2);
      setPricenew(validateOption.sku.newpriced);

      setQuantity(1);
      let path = quantities[0].imagespath + sku + "_1.jpg";
      const updatedOptions = [...optionsselected];
      updatedOptions[0] = { ...updatedOptions[0], optionvalue: optionvalue, sku: validateOption.sku };
      updatedOptions[1] = {
        ...updatedOptions[1], optionvalue: validateOption.newSize, sku: validateOption.sku
      };
      const oldSku = product.productsku
      const _productpath = product.productpath?.replaceAll(oldSku, sku) ?? product.productpath
      setProduct(prev => ({
        ...prev,
        sku: validateOption.sku.sku,
        maxQuantity: validateOption.sku.quantity,
        path: product.path?.replaceAll(oldSku, validateOption.sku.sku) ?? product.path,
        productid: product.productid?.replaceAll(oldSku, validateOption.sku.sku) ?? product.productid,
        productpath: _productpath,
        label: validateOption.sku.specificname,
        productsku: validateOption.sku.sku, // Actualizamos también el valor base
      }));
      setSku(validateOption.sku.sku)
      var _linkInfo =
        (props.productData.category
          ? "/" + props.productData.category + "/"
          : "/productDetails/") +
        (_productpath
          ? _productpath
          : props.productData.label) +
        (props.productData.skuCloned
          ? "?suggestedcolor_" + props.productData.skuCloned
          : "");
      setLinkInfo(_linkInfo)
      setOptionsselected(updatedOptions);
      setPath(path);
      props.productData.path = path
    } catch (Exc) { console.log("set prod exc", Exc) }
  };

  const manageProdCartSize = (_event, banned, optionvalue, sku) => {

    if (process.env.REACT_APP_URL_CONFIG === "http://localhost:8081") {
      console.log("manageProdCartSize _event:", _event)
      console.log("manageProdCartSize banned:", banned)
      console.log("manageProdCartSize optionvalue:", optionvalue)
      console.log("manageProdCartSize sku:", sku)
      console.log("qRequested sku:", qRequested)
      //console.log("storequantities", JSON.stringify(storequantities))
      //console.log("quantities", JSON.stringify(quantities))
    }

    const pricesBySku = new Map();
    for (const p of quantities) {
      pricesBySku.set(String(p.sku), {
        newpriced: p.newpriced,
        newpriced2: p.newpriced2,
        newpricec1: p.newpricec1,
        newpricec2: p.newpricec2,
        specificname: p.specificname
      });
    }
    const updatedStoreQuantities = storequantities.map(item => {
      if (Number(item.storeid) !== Number(storeId)) return item;
      const priceInfo = pricesBySku.get(String(item.sku));
      if (!priceInfo) return item;
      return {
        ...item,
        ...priceInfo
      };
    });

    let validateOption = updateOptionsAll(
      storeId,
      selectedColor,
      optionvalue,
      updatedStoreQuantities, // ANTES storequantities,
      options,
      null,
      props.productConfig.colors
    );
    if (process.env.REACT_APP_URL_CONFIG === "http://localhost:8082") {
      console.log("validateOption", validateOption)
    }
    if (validateOption.sku) {
      setQuantity(1);
      //console.log("optionvalue:::", optionvalue, validateOption?.sku?.price);
      setOptions(validateOption.newOptions);
      setSelectedColor(validateOption.newColor);
      setSelectedSize(validateOption.newSize);
      setPriceold(validateOption.sku.price);

      setDiscount(validateOption.sku.newpriced2);
      setPricenew(validateOption.sku.newpriced);

      //let _priceObj = quantities.find((item) => item.size === optionvalue);
      const updatedOptions = [...optionsselected];
      updatedOptions[0] = {
        ...updatedOptions[0], optionvalue: validateOption.newColor, sku: validateOption.sku
      };
      updatedOptions[1] = { ...updatedOptions[1], optionvalue: optionvalue, sku: validateOption.sku };
      console.log("quantities", quantities)
      //let _path = quantities.find((item) => item.sku === validateOption.sku.sku);
      let path = quantities[0].imagespath + validateOption.sku.sku + "_1.jpg";
      const oldSku = product.productsku
      const _productpath = product.productpath?.replaceAll(oldSku, sku) ?? product.productpath

      console.log("updatedOptions", updatedOptions)
      setProduct(prev => ({
        ...prev,
        sku: validateOption.sku.sku,
        maxQuantity: validateOption.sku.quantity,
        path: product.path?.replaceAll(oldSku, validateOption.sku.sku) ?? product.path,
        productid: product.productid?.replaceAll(oldSku, validateOption.sku.sku) ?? product.productid,
        productpath: _productpath,
        label: validateOption.sku.specificname,
        productsku: validateOption.sku.sku, // Actualizamos también el valor base

      }));
      setSku(validateOption.sku.sku)

      var _linkInfo =
        (props.productData.category
          ? "/" + props.productData.category + "/"
          : "/productDetails/") +
        (_productpath
          ? _productpath
          : props.productData.label) +
        (props.productData.skuCloned
          ? "?suggestedcolor_" + props.productData.skuCloned
          : "");
      setLinkInfo(_linkInfo)
      setOptionsselected(updatedOptions);
      setPath(path);
      props.productData.path = path

    } else {
      console.log("combinacion no permitida")
    }

  };

  const style = {};

  if (props.productData.tagbgcolor) {
    style["backgroundColor"] = props.productData.tagbgcolor;
  }
  if (props.productData.tagcolor) {
    style["color"] = props.productData.tagcolor;
  }

  var tag = props.productData.tag;
  var tagAdd = "";

  var imageSkuSelected = props.productData.productsku
    ? props.productData.productsku
    : props.productData.genericsku;
  if (props.productData.cloned || props.productData.skuCloned) {
    //console.log("clon no igual", imageSkuSelected)

    quantities.map(function (o) {
      if (imageSkuSelected == o.sku) {
        if (o.newpriced2 != null) {
          tag = "-" + parseInt(o.newpriced2 * 100) + "% ";

          if (
            quantities.length != props.productData.allSKusD &&
            props.productData.isLockedCat
          ) {
            tagAdd = getDefValues().selectCodesLabel;
          }
        }
        if (o.newpricec1 != null) {
          tag =
            getComboLabel(o.newpricec1, o.newpricec2, o.price);


          if (
            quantities.length != props.productData.allSKusC &&
            props.productData.isLockedCat
          ) {
            tagAdd = getDefValues().selectCodesLabel;
          }
        }
      }
    });
  } else {
    quantities.map(function (o) {
      if (o.newpriced2 != null) {
        tag = "-" + parseInt(o.newpriced2 * 100) + "% ";
        if (quantities.length != props.productData.allSKusD) {
          tagAdd = getDefValues().selectCodesLabel;
        }
      }
      if (o.newpricec1 != null) {
        tag =
          getComboLabel(o.newpricec1, o.newpricec2, o.price);
        //console.log("datos", quantities.length, props.productData.allSKusC,props.productData.isLockedCat)
        if (quantities.length != props.productData.allSKusC) {
          tagAdd = getDefValues().selectCodesLabel;
        }
      }
    });
  }

  /*tag="-"
  tagAdd=getDefValues().selectCodesLabel*/
  var ctag;
  var cstyle = {};
  if (props.productData.customTag) {
    //console.log("tacg", props.productData.customTag)
    //tag=null
    ctag = props.productData.customTag;
    //	console.log("tacg", ctag.style["font-size"])
    //	console.log("tacg", ctag.style["font-weight"])
    cstyle = {
      background: ctag.style.imagepath === "" && ctag.style.background ? ctag.style.background : "#FFF",
      color: ctag.style.color ? ctag.style.color : "#000",
      fontSize: ctag.style["font-size"]
        ? ctag.style["font-size"] + "px"
        : "16px",
      fontWeight: ctag.style["font-weight"]
        ? ctag.style["font-weight"]
        : "normal",
      textDecoration: ctag.style["text-decoration"]
        ? ctag.style["text-decoration"]
        : "none",
      top: "4px",
      opacity: "1",
    };
    if (ctag.style.position) {
      if (ctag.style.position != "") {
        cstyle["top"] = ctag.style.position + "px";
      }
    }
    if (ctag.style.positionb) {
      if (ctag.style.positionb != "") {
        cstyle["top"] = "initial";
        cstyle["bottom"] = ctag.style.positionb + "px";
      }
    }
    if (ctag.style.align) {
      if (ctag.style.align == "left") {
        cstyle["left"] = "1px";
      } else {
        cstyle["right"] = "1px";
      }
    } else {
      cstyle["right"] = "1px";
    }
    if (ctag.style.opacity) {
      if (ctag.style.opacity == "0.75") {
        cstyle["opacity"] = "0.25";
      } else if (ctag.style.opacity == "0.50") {
        cstyle["opacity"] = "0.50";
      } else if (ctag.style.opacity == "0.25") {
        cstyle["opacity"] = "0.75";
      } else {
        cstyle["opacity"] = "1";
      }
    }
    if (ctag.style.imagepath) {
      cstyle["paddingLeft"] = "0";
      cstyle["paddingRight"] = "0";
      cstyle["imagepath"] = true;
    }
    if (cstyle.top != "initial" && cstyle.right) {
      style["bottom"] = 0;
      style["top"] = "auto";
      //	console.log(style)
    }
  }

  if (props.productData) {
    return (
      <>
        {skucomment && (
          <div
            onClick={() => setShowComment(false)}
            className={`sku-comment-container${showComment ? "" : "-hide"}`}
          >
            <div className="sku-comment-active" tabIndex="-1">
              <div>
                {showComment && (
                  <div className="sku-comment mb-1">
                    {skucomment}
                  </div>
                )}

                <div className="sku-btn-container mb-1">
                  <button
                    onClick={toggleShowComment}
                    className="btn btn-sm btn-outline-secondary"
                  >
                    {getDefValues().closeLabel}
                  </button>

                  <button
                    name={`add__${props.productData.productid}__${elementId}`}
                    disabled={updatingShopCart}
                    onClick={async () => {
                      if (updatingShopCart) return;

                      try {
                        setUpdatingShopCart(true);
                        const data = await addShopCartV2(product, shopCart, quantity);
                        setShopCart(data);
                        setShowComment(false);
                      } catch (error) {
                        console.error("Error al agregar al carrito:", error);
                      } finally {
                        setUpdatingShopCart(false);
                      }
                    }}
                    className="ml-2 btn btn-sm btn-secondary"
                  >
                    <span className="hide-mobile">{getDefValues().btnaddbutton}</span>
                    <span className="hide-web">{getDefValues().shortbtnaddbutton}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="profile-widget">
          <div className="doc-img">
            {tag && (
              <div
                style={style}
                className={tag === "new" ? "product-new-tag" : "product-tag"}
              >
                {tag === "new"
                  ? getDefValues().newLabel
                  : `${tag}${tagAdd ? "*" : ""}`}
              </div>
            )}

            {qRequested > 0 && (
              <div style={style} className="product-event">
                {`${getDefValues().quantityRequestedLabel.toUpperCase()}: `}
                <span className="text-bold h6">{qRequested}</span>
              </div>
            )}

            {tagAdd !== "" && (
              <div className="product-tag-info"> {tagAdd}</div>
            )}

            {ctag && (
              <div style={cstyle} className="custom-product-tag">
                {cstyle.imagepath ? (
                  <img loading="lazy" src={getImagePath(ctag.style.imagepath)} alt={ctag.label || "tag"} />
                ) : (
                  ctag.label
                )}
              </div>
            )}

            <a
              target={target}
              key={"text" + props.productData.productid}
              href={linkInfo}
              tabIndex="-1"
              onMouseEnter={() => windowWidth >= 766 && selectImage(path)}
              onMouseLeave={() => windowWidth >= 766 && selectImage(path)}
            >
              <img
                key={"img" + props.productData.productid}
                name={
                  "manageImage__" +
                  props.productData.productid +
                  "__" +
                  props.productData.path
                }
                className="product-image xxx"
                src={
                  windowWidth < 766 ? getImagePath(props.productData.path) :
                    (path ? getImagePath(path, "sku") : defaultImage)}
              />
            </a>
          </div>
          <div className="pro-content">

            {options && props.productConfig.showVariants ? (
              <div className="option" tabIndex="-1">
                <div
                  style={{
                    display: "block",
                    width: "90%",
                    //background: "#fff",
                    //minHeight: "92px",
                    cursor: "auto",
                  }}
                >
                  {options.map((feat, i) => {
                    // Ocultar en móvil si no es el primer elemento
                    if (i !== 0 && windowWidth < 766) return null;

                    // Si no hay valores suficientes, no mostrar
                    if (feat.optionvalues.length <= 1) return null;

                    const maxVisible = feat.optionvalues[0]?.image ? 4 : 3;
                    return (
                      <div key={`feat_${i}`} id={`feat_${i}`} className="attr-detail attr-color">
                        <div className="row">
                          <div className="col-12 list-filter color-filter-mini">
                            {feat.optionvalues.map((img, j) => {
                              const name = `${feat.optionid}__${img.value}`;
                              const isSelected = optionsselected.some(
                                (s) => s.optionid === feat.optionid && s.optionvalue === img.value
                              );

                              // Mostrar botón "ver más"
                              if (j === maxVisible) {
                                const remaining = feat.optionvalues.length - (img.image ? 4 : 3);
                                return (
                                  <li key={`plus_${j}`}>
                                    <button className="plus-option" id={props.name} name={name}>
                                      <span>
                                        <a target={target} href={linkInfo} tabIndex="-1">
                                          +{remaining}
                                        </a>
                                      </span>
                                    </button>
                                  </li>
                                );
                              }

                              // Limitar a los primeros visibles
                              if (j > maxVisible) return null;

                              const buttonProps = {
                                id: props.name,
                                name: `selectOption__${props.productData.productid}__${feat.optionid}__${img.value}`,
                                onClick: () => {
                                  console.log("entra");

                                  const handler = img.image
                                    ? manageProdCartColor
                                    : manageProdCartSize;

                                  handler(
                                    `selectOption__${props.productData.productid}__${feat.optionid}__${img.value}`,
                                    img.banned,
                                    img.value,
                                    img.sku
                                  );
                                }
                              };

                              return (
                                <li key={`value_${j}`}>
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      opacity: img.banned ? 0.7 : 1,
                                    }}
                                  >
                                    {img.image && img.image.length > 7 ? (
                                      <>
                                        <button className={(isSelected ? "active-button-option" : "no-button")} {...buttonProps}>
                                          <img
                                            loading="lazy "
                                            src={getImagePath(img.image)}
                                          />
                                        </button>
                                        {/*isSelected && <div className="active-mini-div" />*/}
                                        {img.banned && <div className="ban-div-mini" />}
                                      </>
                                    ) : (
                                      <button
                                        className={isSelected ? "active-option " : ""}
                                        {...buttonProps}
                                      >
                                        {img.banned ? (
                                          <div className="ban-option-mini">
                                            <span>{img.label}</span>
                                          </div>
                                        ) : (
                                          <span>{img.label}</span>
                                        )}
                                      </button>
                                    )}
                                  </div>
                                </li>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              windowWidth < 766 && <div className="option" tabIndex="-1" />
            )}

            <div className="row align-items-start product-info-first-div">
              <p>
                {" "}
                <a
                  target={target}
                  key={"img" + props.productData.productid}
                  name={
                    "manageHref__" +
                    props.productData.productid +
                    "__" +
                    props.productData.path
                  }
                  href={linkInfo}
                  tabIndex="-1"
                >
                  {" "}
                  {product.label}
                </a>
              </p>

            </div>
          </div>
          {windowWidth < 766 && <>
            {props?.productData?.options[1]?.optionvalues?.length > 1 &&
              <a
                href={linkInfo}
                style={{ fontSize: 11 }}
                target={target}
                className="floating-ver-tallas"
                aria-label="Ver tallas del producto"
              >
                Ver tallas
              </a>
            }
          </>}
        </div>

        <div className="row align-items-center text-center font-14">
          <div className="col-12">
            {validateNumber(discount) ? (
              <>
                <span className="product-price-new">
                  {props.productData.currency}{" "}
                  {toFixed(pricenew)}
                </span>
                <span className="product-price-old">
                  {" " +
                    props.productData.currency +
                    " " +
                    toFixed(priceold)}
                </span>
              </>
            ) : (
              <span className="product-price">
                {props.productData.currency + " " + toFixed(priceold)}
              </span>
            )}
          </div>
        </div>

        <div className="row align-items-center text-center font-14">
          <div className="col-12 special-col ">
            <div className="product-actions flex">
              <div className="product-extra-link2-mini product-extra-quantity">
                <button
                  id={props.name}
                  name={"decrease__" + props.productData.productid}
                  onClick={() => {
                    //props.productConfig.manageCart();
                    setQuantity(prev => Math.max(1, prev - 1));
                  }}
                  className="product-qty-updwown"
                >
                  <i className="fas fa-minus"></i>
                </button>
                <input
                  id={props.name}
                  type="text"
                  className="product-qty"
                  name={"quantity__" + props.productData.productid}
                  value={quantity}
                  onChange={(e) => {
                    const value = e.target.value.trim();
                    const parsed = Number(value);
                    // Si no es un número válido, usar 1 como mínimo
                    const newQuantity = isNaN(parsed) ? 1 : parsed;
                    // Limitar entre 1 y product.maxQuantity
                    const limitedQuantity = Math.max(1, Math.min(newQuantity, product.maxQuantity));
                    setQuantity(limitedQuantity);
                  }}
                />
                <button
                  id={props.name}
                  name={"increase__" + props.productData.productid}
                  onClick={() => {
                    //props.productConfig.manageCart();
                    console.log("p", product)
                    setQuantity(prev => Math.min(prev + 1, product.maxQuantity));
                  }}
                  className="product-qty-updwown"
                >
                  <i className="fas fa-plus"></i>
                </button>
              </div>
              <div className="product-extra-link2-mini">
                {action == "" ? (
                  <button
                    id={props.name}
                    disabled={updatingShopCart}
                    name={"add__" + props.productData.productid}
                    onClick={async () => {

                      if (windowWidth < 766 && props?.productData?.options[1]) {
                        console.log("redirecting", linkInfo)
                        window.location.href = linkInfo
                        //window.location.reload();
                      } else {
                        if (updatingShopCart) {
                          console.log("NOOOOOOOOOO");
                        } else {
                          setUpdatingShopCart(true);
                          //console.log("shopCart", shopCart, updatingShopCart);
                          let data = await addShopCartV2(
                            product,
                            shopCart,
                            quantity
                          );
                          setShopCart(data);
                          setUpdatingShopCart(false);

                          setShowComment(false);

                        }

                      }
                    }}
                    className="btn detail-add-button-mini"
                  >
                    <span className="hide-mobile">
                      {" "}
                      {getDefValues().btnaddbutton}
                    </span>
                    <span className="hide-web">
                      {" "}
                      {getDefValues().shortbtnaddbutton}
                    </span>
                  </button>
                ) : (
                  <>
                    {action == "addEventList" ? (
                      <button
                        id={props.name}
                        name={
                          "addEventList__" +
                          props.productData.productid +
                          "__" +
                          elementId
                        }
                        onClickX={props.productConfig.manageCart}
                        onClickX2={() => {
                          addEventCartV2(product, quantity);
                          setShowComment(false);
                        }}

                        onClick={async () => {
                          if (updatingShopCart) {
                            console.log("NOOOOOOOOOO");
                          } else {
                            setUpdatingEventCart(true);
                            //console.log("eventQty", eventQty, updatingEventCart);
                            addEventCartV2(product, quantity);
                            setEventQty(prev => prev + quantity);
                            setUpdatingEventCart(false);
                            setShowComment(false);
                          }
                        }}



                        className="btn detail-add-button-mini-secondary"
                      >
                        <span> {getDefValues().addEventListButton}</span>
                      </button>
                    ) : (
                      ""
                    )}

                    {action == "addEventCart" ? (
                      <button
                        id={props.name}
                        name={
                          "add__" +
                          props.productData.productid +
                          "__" +
                          elementId
                        }
                        onClick={async () => {
                          //addShopCartV2(product);

                          if (updatingShopCart) return;

                          try {
                            setUpdatingShopCart(true);
                            const data = await addShopCartV2(product, shopCart, quantity);
                            setShopCart(data);
                            setShowComment(false);
                          } catch (error) {
                            console.error("Error al agregar al carrito:", error);
                          } finally {
                            setUpdatingShopCart(false);
                          }
                          setShowComment(false);
                        }}
                        className="btn detail-add-button-mini-secondary"
                      >
                        <span className="hide-mobile">
                          {" "}
                          {getDefValues().btnaddbutton}
                        </span>
                        <span className="hide-web">
                          {" "}
                          {getDefValues().shortbtnaddbutton}
                        </span>
                      </button>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {action == "" ? (
                  <button
                    id={props.name}
                    name={"favorite__" + props.productData.productid + "__" + product.sku}
                    onClick={props.productConfig.manageCart}
                    aria-label="Add To Wishlist"
                    className={
                      props.productConfig.favorite
                        ? "towishlist-active"
                        : "towishlist"
                    }
                  ></button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return "NO Product DATA";
  }
};
LoadProduct.propTypes = {};

export default LoadProduct;
